import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import DatePicker from 'react-datepicker';
import { GrRefresh } from 'react-icons/gr';

import Button from '../../../components/Button/Button';
import { FormField } from '../../../components/FormField';
import { useGenerateStatement } from '../../../network/queries/Admin/Statements/useGenerateStatement';
import { CustomSelect } from '../../../components/Shared/CustomSelect';
import { useSetFilters } from '../../../hooks/useSetFilters';
import { useQuery } from '../../../utils/useQuery';
import { useGetChains } from '../../../network';

export const StatementsFilter = ({ refetch }) => {
    const setFilters = useSetFilters();
    const { t } = useTranslation();
    const query = useQuery();
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');

    const by = query.get('by') || ''; // weekly, monthly, custom
    const chain = parseInt(query.get('chain') || ''); // chain id

    const { mutate } = useGenerateStatement();
    const { data: chainsList = [] } = useGetChains();

    const dateOptions = [
        { value: '', label: t('All') },
        { value: 'week', label: t('By Week') },
        { value: 'month', label: t('By Month') },
        { value: 'custom', label: t('Custom') },
    ];

    const chainsOptions = [{ value: '', label: t('All Chains') }, ...chainsList.map(chain => ({ value: chain.id, label: chain.name }))];

    const defaultDateOption = dateOptions.find((option) => option.value === by);
    const defaultChainOption = chainsOptions.find((option) => option.value === chain);

    const onChangeDate = ({ value }) => setFilters({ page: 1, by: value });
    const onChangeChain = ({ value }) => setFilters({ page: 1, chain: value });

    return (
        <div className="">
            <div className="flex flex-col gap-4">
                <div className="flex justify-between gap-6">
                    <div className="flex gap-3 items-center">
                        <FormField>
                            <CustomSelect placeholder={t('By Week')} className="text-left min-w-[125px]" options={dateOptions} defaultValue={defaultDateOption} onChange={onChangeDate} />
                        </FormField>
                        <FormField>
                            <CustomSelect placeholder={t('All Chains')} className="text-left min-w-[125px]" options={chainsOptions} value={defaultChainOption} onChange={onChangeChain} />
                        </FormField>
                        <FormField htmlFor="start_date">
                            <DatePicker
                                name="start_date"
                                placeholderText={t('Start Date')}
                                selected={startDate}
                                onChange={(value) => setStartDate(value)}
                                className="block w-[130px] w-full rounded-md border-gray-300 shadow-sm sm:text-sm bg-gray-50 focus:ring-gray-300 focus:border-gray-200"
                            />
                        </FormField>
                        <FormField htmlFor="end_date">
                            <DatePicker
                                name="end_date"
                                placeholderText={t('End Date')}
                                selected={endDate}
                                onChange={(value) => setEndDate(value)}
                                className="block w-[130px] w-full rounded-md border-gray-300 shadow-sm sm:text-sm bg-gray-50 focus:ring-gray-300 focus:border-gray-200"
                                minDate={startDate}
                            />
                        </FormField>
                        <GrRefresh onClick={refetch} size={32} cursor="pointer" />
                    </div>
                    <div className="flex gap-6">
                        <Button onClick={() => mutate({ start_at: startDate, end_at: endDate, chain_id: chain || null })} isUpperCase={false}>
                            {t('Generate Report')}
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    );
};
